// @ts-nocheck
export const localeCodes =  [
  "cs",
  "en"
]
export const localeLoaders = {
  cs: [
    {
      key: "locale_cs_46js_975cfd93",
      load: () => import("#nuxt-i18n/975cfd93" /* webpackChunkName: "locale_cs_46js_975cfd93" */),
      cache: false
    }
  ],
  en: [
    {
      key: "locale_en_46js_532610f4",
      load: () => import("#nuxt-i18n/532610f4" /* webpackChunkName: "locale_en_46js_532610f4" */),
      cache: false
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "cs",
    iso: "cs-CZ",
    name: "Czech",
    language: undefined
  },
  {
    code: "en",
    iso: "en-US",
    name: "English",
    language: undefined
  }
]
/** client **/

/** client-end **/